import React from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import defaultTexts from '../../../texts/texts'
import constants from '../../../config/constants'
import useWindowDimensions from '../../_common/WindowDimesnions'
import BillingDepositsWrapper from './deposits/billingDepositsWrapper'

const AccountsWrapper = (props) => {
  const { billingServices } = props
  const theme = useTheme()
  const { width } = useWindowDimensions()

  const labelStyle = {
    color: theme.palette.vodka,
    fontSize: width >= constants.lgBreakpoint ? '18px' : '16px',
    fontWeight: '500',
  }

  const labelArrowStyle = {
    color: theme.palette.oxfordBlue,
  }

  return (
    <>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='flex-start'
        spacing={3}
        sx={{
          padding: '20px 0px 40px 20px',
        }}
      >
        <Box sx={labelStyle}>{defaultTexts.accounting}</Box>
        <ArrowForwardIosIcon fontSize='small' sx={labelArrowStyle} />
        <Box sx={labelStyle}>{defaultTexts.accounts}</Box>
      </Stack>
      
      <Box sx={{ padding: '0px 20px 20px 10px' }}>
        <BillingDepositsWrapper
          billingServices={billingServices}
        />
      </Box>      
    </>
  )
}

export default AccountsWrapper